module.exports = __webpack_public_path__ + "img/server-error.68fb2d56.svg";